/* eslint-disable */
import { Component } from 'react';
import {Card, Col, Row} from 'react-bootstrap';
import FileDownload from 'react-file-download';
import {toast} from 'react-toastify';
import Badge from './upload-history-badge';
import Field from './upload-history-field';
import {dateTimeFormat, ucfirst} from '../../../utils/commonFunctions';
import api from '../../../irelandApi';
import ToastMessage from '../../common/toast-message';

class UploadHistoryPanel extends Component {
  download(event, url, name) {
    event.preventDefault();
    const fileName = `errors_${name}`;
    api.get(`/api/admin/data_imports/download/${url}`)
      .then((response) => {
        FileDownload(response.data, fileName);
      })
      .catch(() => {
        toast.error(<ToastMessage iconStyle="error" message={`${fileName} not found on S3`}/>);
      });
  }

  render() {
    const {data} = this.props;

    const typeMap = {
      failed: 'Failed',
      complete: 'Completed',
      completed: 'Completed',
      in_progress: 'In Progress'
    };
    let fields = [];
    let otherFields = [];
    const extraFields = [];

    if (data.status === 'complete') {
      fields = [
        {
          label: 'Number of lines in file',
          value: data.number_of_lines,
        },
        {
          label: 'Number of lines processed',
          value: data.number_of_lines_processed,
        },
      ];

      otherFields = [];

      if (data.number_of_errors > 0) {
        otherFields.push({
          label: 'Number of errors',
          value: data.number_of_errors,
        });
        otherFields.push({
          label: (
            <a
              className="upload_error_link"
              href={data.links.download_errors}
              onClick={event => this.download(event, data.links.download_errors, data.upload_name)}
            >
              download errors
            </a>),
          value: '',
        });
      }
    }

    if (typeof data.fail_reason === 'string' && data.fail_reason.length > 0) {
      fields.push(
        {
          label: 'Fail reason',
          value: data.fail_reason,
        }
      );
    }

    for (const attribute in data.extra_attributes) {
      const label = ucfirst(attribute.split('_')
        .join(' '));
      extraFields.push({
        label,
        value: data.extra_attributes[attribute]
      });
    }

    return (
      <Card className={'upload-history'}>
        <Card.Body>
          <Badge className={data.status} type={typeMap[data.status]}/>
          <Row>
            <Col md={8}>
              <Field label="Upload date/time">
                {dateTimeFormat(data.created_at)}
              </Field>
              <Field label="File name">
                {data.upload_name}
              </Field>
              {fields.map((value, key) => (
                <Field key={key} label={value.label}>
                  {value.value}
                </Field>
              ))}
              {extraFields.map((value, key) => (
                <Field key={key} label={value.label}>
                  {value.value}
                </Field>
              ))}
            </Col>
            <Col md={4}>
              {otherFields.map((value, key) => (
                <Field key={key} label={value.label}>
                  {value.value}
                </Field>
              ))}
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  }
}

export default UploadHistoryPanel;
